import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('stack-valor')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full bg-gradient-to-b from-[#D8F3DC] to-white py-8 md:py-14" data-id="element-110">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-111">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-112">
          <h1 className="font-heading text-xl md:text-3xl lg:text-4xl font-bold text-[#2D6A4F] mb-4 leading-tight" data-id="element-113">
            Domina el Huerto en Balcón sin morir en el intento
          </h1>
          <p className="text-sm md:text-base text-gray-700 mb-6 max-w-3xl mx-auto" data-id="element-114">
            El sistema exacto para convertir un metro cuadrado de cemento en una
            fuente inagotable de comida fresca, orgánica y libre de precios
            inflados.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="flex justify-center mb-6" data-id="element-115">
          <img src="https://cdn.magicpatterns.com/uploads/5HAaFmwMrmg33tvKYCJdew/portada_landing.png" alt="Maestría en Huerto Urbano" className="max-w-full h-auto rounded-lg shadow-2xl w-full md:w-2/3 lg:w-1/2" data-id="element-116" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex justify-center" data-id="element-117">
          <Button size="lg" onClick={scrollToOffer} className="bg-[#2D6A4F] hover:bg-[#40916C] text-white text-base px-6 py-5 rounded-full shadow-lg hover:shadow-xl transition-all" data-id="element-118">
            ¡QUIERO MI COSECHA EN 30 DÍAS!
          </Button>
        </motion.div>
      </div>
    </section>;
}